import React from 'react'
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks } from './NavbarElements'
import { FaBars } from 'react-icons/fa'
import { VscThreeBars } from "react-icons/vsc";

const index = ({ toggle }) => {
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='./'>Jonathan Root</NavLogo>

        <MobileIcon onClick={toggle}>
          <VscThreeBars />
        </MobileIcon>
        <NavMenu>
          <NavItem>
            <NavLinks to='/about'>ABOUT</NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to='/gallery'>GALLERY</NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to='/press'>PRESS</NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to='/contact'>CONTACT</NavLinks>
          </NavItem>
        </NavMenu>
      </NavbarContainer>
    </Nav>
  )
}

export default index